export default {
	name: 'global',
	store() {
		return {
			megamenu: {
				visible: false,
				index: null
			},

			isMinicartVisible: false,

			_refreshProductSectionTimeout: null,

			init() {
				document.addEventListener('DOMContentLoaded', () => {
					// @todo: use hooks to get bounding client rect
					this.announcementBar = document.querySelector('.announcement-bar-section')
					this.header = document.getElementById('orsay-header')

					this.onWindowResizeHandler()
					// @todo: use hooks for resize event
					document.addEventListener('resize', () => {
						this.onWindowResizeHandler()
					})
				})

				this.initLiquidAjaxCart()
				this.initShippingBar()
			},

			initLiquidAjaxCart() {
				document.addEventListener('liquid-ajax-cart:request-end', event => {
					if (event) {
						const { requestState } = event.detail
						if (requestState.requestType === 'add') {
							this.isMinicartVisible = true
						}
					}
					// Refresh product section after cart changes
					this.refreshProductSection()
				})
			},

			refreshProductSection() {
				// Debounce to avoid multiple calls
				if (this._refreshProductSectionTimeout) {
					clearTimeout(this._refreshProductSectionTimeout)
				}

				this._refreshProductSectionTimeout = setTimeout(() => {
					// Check if we're on a product page
					const productSection = document.querySelector('[id^="MainProduct-"]')
					if (!productSection) return

					const sectionId = productSection.dataset.section
					if (!sectionId) return

					// Get current product URL
					const productUrl = window.location.pathname
					if (!productUrl.includes('/products/')) return

					// Find the product-form__buttons element to refresh
					const productFormButtons = productSection.querySelector('.product-form__buttons')
					if (!productFormButtons) return

					// Fetch the updated product section using the same format as renderProductInfo
					fetch(`${productUrl}?section_id=${sectionId}`)
						.then(response => response.text())
						.then(html => {
							const parser = new DOMParser()
							const doc = parser.parseFromString(html, 'text/html')
							const newSection = doc.querySelector(`[id="MainProduct-${sectionId}"]`)
							
							if (newSection) {
								const newProductFormButtons = newSection.querySelector('.product-form__buttons')
								if (newProductFormButtons && productFormButtons) {
									productFormButtons.innerHTML = newProductFormButtons.innerHTML
								}
							}
						})
						.catch(error => {
							console.error('Error refreshing product form buttons:', error)
						})
				}, 300) // 300ms debounce
			},

			initShippingBar() {
				this.shippingBar = document.getElementById('oa-shipping-bar')
				const giftProductIdAttr = this.shippingBar?.getAttribute('data-gift-product-id')
				const giftProductId = giftProductIdAttr ? Number(giftProductIdAttr) : null

				let isRemovingGift = false

				if (!giftProductId || isNaN(giftProductId)) {
					return
				}

				document.addEventListener('liquid-ajax-cart:request-end', event => {
					if (!event || isRemovingGift) {
						return
					}

					const { requestState, cart } = event.detail

					if (!cart || !cart.items || !Array.isArray(cart.items)) {
						return
					}

					if ((requestState.requestType === 'add' || requestState.requestType === 'change') && cart.total_price < 15000) {
						const giftItem = cart.items.find(item => item.product_id === giftProductId)

						if (giftItem) {
							isRemovingGift = true
							window.liquidAjaxCart.change({
								items: [
									{
										id: giftItem.key,
										quantity: 0
									}
								]
							})

							setTimeout(() => {
								isRemovingGift = false
							}, 500)
						}
					}
				})
			},

			onWindowResizeHandler() {
				if (this.announcementBar) document.documentElement.style.setProperty('--announcement-bar-height', `${this.announcementBar.offsetHeight}px`)
				if (this.header) document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`)
			}
		}
	}
}
